export enum LendingStatusBadgeEnum {
  APPROVED = 'approved',
  APPROVED_COUNTER = 'approvedCounter',
  COUNTER = 'counter',
  DENIED = 'denied',
  LOADING = 'loading',
  RECOMMENDED = 'recommended',
}

export enum LendingValueBadgeEnum {
  ORIGINAL_REQUESTED_TERMS = 'originalRequest',
  BEST_APR = 'bestAPR',
  NEXT_BEST_APR = 'nextBestAPR',
  NEEDS_ADJUSTMENT = 'needsAdjustment',
  APPLICANT_DENIED = 'applicantDenied',
  LONGER_TERM_LOWER_APR = 'longerTermLowerApr',
  SHORTER_TERM_LOWER_APR = 'shorterTermLowerApr',
  HIGHER_DOWN_PAYMENT_LOWER_APR = 'higherDownPaymentLowerApr',
}
